import { makeStyles, Select, MenuItem } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import * as priceSchemeTypes from '../../Config/priceSchemeTypes';
import { fromNewDateFormatToYYYYMMDDHHmmssDash } from '../../Helpers/dateHelper';
import { fromField, dryFromField } from '../../Config/constants';
import PriceSchemeTable from '../StepComponents/PriceSchemeTable';

export default function PriceSchemeDialog(props) {
    const classes = useStyles();

    const [currentPriceSchemeType, setCurrentPriceSchemeType] = useState(1);

    const { t } = useTranslation();

    const setSelectedData = (price, from, to) => {
        if (price > 0) {
            props.actions.SetPrice(`${price}`);
            props.actions.SetFromDate(fromNewDateFormatToYYYYMMDDHHmmssDash(new Date(from)));
            props.actions.SetToDate(fromNewDateFormatToYYYYMMDDHHmmssDash(new Date(to)));
            props.actions.SetPriceSchemeDialogVisible(false);
        }
    }

    const returnPriceschemeTable = (scheme) => {
        return (
            <PriceSchemeTable headers={scheme.Headers} rows={scheme.Rows.map(r => {
                let fromDate = new Date(Date.parse(r.From));
                let toDate = new Date(Date.parse(r.To));
                let periodText = `${fromDate.getDate()}/${fromDate.getMonth() + 1} - ${toDate.getDate()}/${toDate.getMonth() + 1}`;
                return (createRowData(fromDate, toDate, periodText, r.Cells))
            }
            )} setSelectedData={setSelectedData}></PriceSchemeTable>
        )
    }

    let priceSchemeTables = []
    props.priceSchemes.map(scheme => {
        priceSchemeTables.push({
            priceschemeType: scheme.PriceSchemeType, table:
                returnPriceschemeTable(scheme)
        })
    })

    console.log(priceSchemeTables)

    // var rows = scheme.Rows.map(r => {
    //     let fromDate = new Date(Date.parse(r.From));
    //     let toDate = new Date(Date.parse(r.To));
    //     let periodText = `${fromDate.getDate()}/${fromDate.getMonth() + 1} - ${toDate.getDate()}/${toDate.getMonth() + 1}`;
    //     return (createRowData(fromDate, toDate, periodText, r.Cells))
    // }
    // )


    // foreach pricescheme
    // fromShedRowes = scheme.Rows.map(r => {
    //     let fromDate = new Date(Date.parse(r.From));
    //     let toDate = new Date(Date.parse(r.To));
    //     let periodText = `${fromDate.getDate()}/${fromDate.getMonth() + 1} - ${toDate.getDate()}/${toDate.getMonth() + 1}`;
    //     return (createRowData(fromDate, toDate, periodText, r.Cells))
    // }
    // )
    // fromShedTable = <PriceSchemeTable headers = {scheme.Headers} rows = {rows} setSelectedData = {setSelectedData}></PriceSchemeTable>

    function createRowData(fromDate, toDate, periodText, cells) {
        return { fromDate, toDate, periodText, cells };
    }

    const closeDialog = () => {
        props.actions.SetPriceSchemeDialogVisible(false);
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.addPage.priceSchemeDialogVisible}
            onClose={closeDialog}
            aria-labelledby="draggable-dialog-title"
        >
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select2"
                className={classes.weekMonthPicker}
                value={currentPriceSchemeType}
                onChange={(e) => setCurrentPriceSchemeType(e.target.value)}
            >
                {priceSchemeTypes.Types.map(x => {
                    return (
                        <MenuItem value={x.ID}>{x.value}</MenuItem>)
                })}
            </Select>
            {priceSchemeTables.find(x => x.priceschemeType === currentPriceSchemeType).table}
            <div className={classes.buttons}>
                <button className={classes.button} onClick={() => closeDialog()}>
                    {t("CLOSE")}
                </button>
            </div>
        </Dialog>



    )

}

const useStyles = makeStyles(() => ({

    weekMonthPicker: {
        height: 44,
        backgroundColor: '#F1F1F1',
        borderColor: 'black',
        borderWidth: 1,
        marginLeft: 10,
        marginBottom: 10
    },
    dialogContainer: {
        width: "800px !important",
        height: "320px !important",
        margin: "auto",
        "& > div > div": {
            backgroundColor: '#EFEFEF',
            maxHeight: "none",
            maxWidth: "none",
            overflowY: "none",
            width: "1000px",
            padding: "10px"
        },
    },
    buttons: {
        textAlign: "center",
        height: "40px",
        paddingTop: "10px"
    },
    button: {
        fontFamily: "Roboto",
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "#1976d2",
        color: "white",
        height: "30px",
        width: "80px",
        fontSize: "14px",
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "20px !important",
        },
        paddingTop: "30px",
        paddingBottom: "20px"
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingLeft: "20px",
        paddingRight: "20px",
        height: "50px"
    },

    uiTextField: {
        width: "95%",
        backgroundColor: "white"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        textAlign: "left"
    },

}));